
import React, { useState, useEffect } from 'react';
import { fetchPaginatedProducts } from '../../services/productService/productService';
import ProductList from '../../components/ProductList/ProductList';
import { Helmet } from 'react-helmet';
import './AllProducts.css';
import { useNavigate } from 'react-router-dom';

const AllProducts = () => {
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('All');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);

  const productsPerPage = 12;
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    fetchPaginatedProducts(currentPage - 1, productsPerPage)
      .then((data) => {
        setProducts(data.content);
        setTotalPages(data.totalPages);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error loading products:', error);
        setLoading(false);
      });
  }, [currentPage]);

  const filteredProducts = products.filter((product) => {
    const matchesSearch = product.name?.toLowerCase().includes(search.toLowerCase());
    const matchesCategory =
      category === 'All' ||
      (product.category || '').toLowerCase() === category.toLowerCase();
    return matchesSearch && matchesCategory;
  });

  return (
    <section className="all-products-wrapper">
      <Helmet>
        <title>All Products | UBR Engineering Works</title>
        <meta
          name="description"
          content="Browse the complete range of industrial machinery manufactured by UBR Engineering Works. Filter by category and search for your desired product."
        />
        <meta
          name="keywords"
          content="All products UBR Engineering, industrial machinery, hydraulic machines, lathe machines, drilling, milling, filter, search"
        />
        <meta name="author" content="UBR Engineering Works" />
      </Helmet>

      <h2 className="all-products-heading">All Products</h2>

      <div className="all-products-controls" aria-label="Product Filters">
        <input
          type="text"
          placeholder="Search products..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1);
          }}
          className="search-input"
          aria-label="Search products"
        />
        <select
          value={category}
          onChange={(e) => {
            setCategory(e.target.value);
            setCurrentPage(1);
          }}
          className="category-select"
          aria-label="Filter by category"
        >
          <option value="All">All Categories</option>
          <option value="PVC Cable Extruder">PVC Cable Extruder</option>
          <option value="PVC Compound Machine">PVC Compound Machine</option>
          <option value="PVC Mixture">PVC Mixture</option>
          <option value="Stranding Machine">Stranding Machine</option>
          <option value="Armouring Machine">Armouring Machine</option>
          <option value="Core-Laying Machine">Core-Laying Machine</option>
          <option value="Copper Buncher">Copper Buncher</option>
          <option value="Take-Ups">Take-Ups</option>
          <option value="Pay-Offs">Pay-Offs</option>
          <option value="Coiling Machines">Coiling Machines</option>
        </select>
      </div>

      {loading ? (
        <p className="loading-text">⏳ Loading products...</p>
      ) : (
        <ProductList products={filteredProducts} />
      )}

      <div className="pagination-wrapper" aria-label="Pagination Navigation">
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i}
            onClick={() => setCurrentPage(i + 1)}
            className={`page-btn ${currentPage === i + 1 ? 'active' : ''}`}
            aria-current={currentPage === i + 1 ? 'page' : undefined}
            aria-label={`Go to page ${i + 1}`}
          >
            {i + 1}
          </button>
        ))}
      </div>

      <button
        className="back-button"
        style={{
          margin: '2rem auto 0',
          display: 'block',
          padding: '0.75rem 2rem',
          fontSize: '1.1rem',
          fontWeight: 'bold',
          borderRadius: '30px',
          background: 'linear-gradient(90deg, #ff512f 0%, #dd2476 100%)',
          color: '#fff',
          border: 'none',
          boxShadow: '0 4px 16px rgba(221,36,118,0.15)',
          cursor: 'pointer',
          letterSpacing: '1px',
          transition: 'background 0.3s, transform 0.2s',
        }}
        onClick={() => navigate(-1)}
        aria-label="Go back"
        onMouseOver={e => e.currentTarget.style.background = 'linear-gradient(90deg, #dd2476 0%, #ff512f 100%)'}
        onMouseOut={e => e.currentTarget.style.background = 'linear-gradient(90deg, #ff512f 0%, #dd2476 100%)'}
      >
        ← Back
      </button>
    </section>
  );
};

export default AllProducts;
